import { FETCH_DATA } from '../actions/insiders';

export default function insiders(state = {}, action) {
    switch (action.type) {

    case FETCH_DATA.REQUEST:
        return Object.assign({}, state, {
            [action.meta.symbol]: Object.assign({},
                state[action.meta.symbol] || {},
                { isLoading: true },
            ),
        });

    case FETCH_DATA.SUCCESS:
        return Object.assign({}, state, {
            [action.meta.symbol]: {
                isLoading: false,
                insiders: action.payload.map(insider => insider.values).reverse(),
            },
        });

    case FETCH_DATA.FAILURE:
        return {
            [action.meta.symbol]: { isLoading: false },
        };

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/insiders.js
 **/